import {strokeData} from './resources/strokeData'

export const countStroke = (char: string) => {
  if (!char) char = ''
  const xcode = char.charCodeAt(0).toString(16).toUpperCase()
  if (strokeData[xcode]) return strokeData[xcode]
  return NaN
}
